var $win = $(window);

jQuery(function ($) {

  $('.overlay').delay(500).fadeOut('slow');
  $('.slider').slick({
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 1500,
    speed: 1500,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
  });


  var pagetop = $('#page-top');
  var footerOffset;
  // pagetop.hide();


  $(window).scroll(function () {
     if ($(this).scrollTop() > 100) {
          $('.yohaku-header').addClass('-scroll');
          $('.yohaku-logo').addClass('-scroll');
          $('.yohaku-nav').addClass('-scroll');
          $('.yohaku-right-nav').addClass('-scroll');
     } else {
          $('.yohaku-header').removeClass('-scroll');
          $('.yohaku-logo').removeClass('-scroll');
          $('.yohaku-nav').removeClass('-scroll');
          $('.yohaku-right-nav').removeClass('-scroll');
     };
    //  if ($(this).scrollTop() > 100) {
    //       pagetop.fadeIn();
    //  } else {
    //       pagetop.fadeOut();
    //  };
    //  scrollHeight = $(document).height();
    //  scrollPosition = $(window).height() + $(window).scrollTop();
    //  footHeight = $(".yohaku-footer").innerHeight();
    //  footHeight2 = "calc(2rem + " + footHeight + "px)";
    //  if (scrollHeight - scrollPosition <= footHeight) {
    //   $("#page-top").css({ position: "absolute", bottom: footHeight2 , right: 0 });
    //       } else {
    //   $("#page-top").css({ position: "fixed", bottom: "2rem" , right: "6rem"});
    //       }
  });
  pagetop.click(function () {
     $('body, html').animate({ scrollTop: 0 }, 500);
     return false;
  });




  //ハンバーガーメニューとスクロール制御      
  var state = false;
  var scrollpos;
  $('.toggle,.-shopLink').on('click', function () {
    if (state == false) {
      scrollpos = $(window).scrollTop();
      $('body').addClass('-open');
      $('.yohaku-left-nav').addClass('-open fadein_anime');
      $('.toggle_wrap').addClass('-open fadein_anime');
      $('.toggle').addClass('active');
      state = true;
    } else {
      window.scrollTo(0, scrollpos);
      $('body').removeClass('-open');
      $('.yohaku-left-nav').removeClass('-open fadein_anime');
      $('.toggle_wrap').removeClass('-open fadein_anime');
      $('.toggle').removeClass('active');
      state = false;
    }
  });

  $('.slider-image').slick({
     dots: true, 
     autoplay: true,
     autoplaySpeed: 3000,
     pauseOnHover: true,
  });    
});

function incrementValue() {
  var value = parseInt(document.getElementById('Quantity').value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  document.getElementById('Quantity').value = value;
}

function decrementValue() {
  var value = parseInt(document.getElementById('Quantity').value, 10);
  value = isNaN(value) ? 0 : value;
  value--;
  document.getElementById('Quantity').value = value;
}